// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"1ea12ecd","661":"df83c92e","908":"df83c92e"}[chunkId] + ".chunk.css";
};